export default "__VITE_ASSET__DR$9rl6f__"